module.exports = __webpack_public_path__ + "static/develop-8a3ca48974f2f08ab6a8f2125b303cb7.svg";